import { lazy } from 'react'

const V2ModalsMap = {
  autoLogout: {
    label: 'Still there?',
    Content: lazy(() => import('../v2Modals/AutoLogout/Content')),
    Footer: lazy(() => import('../v2Modals/AutoLogout/Footer')),
  },
  confirmEndCall: {
    label: ({ visit }) => `Are you sure you want to end this ${visit?.isSuccess ? 'session' : 'visit'}?`,
    Content: lazy(() => import('../v2Modals/ConfirmEndCall/Content')),
    Footer: lazy(() => import('../v2Modals/ConfirmEndCall/Footer')),
  },
  confirmCrisisCallConnection: {
    label: 'Ready to Start Crisis Visit?',
    Content: lazy(() => import('../v2Modals/ConfirmCrisisCallConnection/Content')),
    Footer: lazy(() => import('../v2Modals/ConfirmCrisisCallConnection/Footer')),
  },
  confirmLanguageLineCall: {
    label: 'Call Language Line',
    Content: lazy(() => import('../v2Modals/ConfirmLanguageLineCall/Content')),
    Footer: lazy(() => import('../v2Modals/ConfirmLanguageLineCall/Footer')),
  },
  rescheduleVisit: {
    label: 'Reschedule Visit',
    Content: lazy(() => import('../v2Modals/RescheduleVisit')),
  },
  requestReschedule: {
    label: 'Request Reschedule',
    Content: lazy(() => import('../v2Modals/RequestReschedule')),
    Footer: lazy(() => import('../v2Modals/RequestReschedule/Footer')),
    Container: lazy(() => import('../v2Modals/RequestReschedule/Container')),
    footerVariant: 'right',
  },
  rescheduleConfirmation: {
    label: 'Update Availability',
    Content: lazy(() => import('../v2Modals/RescheduleConfirmation')),
    Footer: lazy(() => import('../v2Modals/RescheduleConfirmation/Footer')),
    footerVariant: 'right',
  },
  cancelVisitV2: {
    label: 'Cancel Visit',
    Content: lazy(() => import('../v2Modals/CancelVisit')),
    Footer: lazy(() => import('../v2Modals/CancelVisit/Footer')),
    Container: lazy(() => import('../v2Modals/CancelVisit/Container')),
    footerVariant: 'right',
  },
  memberMedication: {
    label: ({ medicationId }) => `${medicationId ? 'Edit' : 'Add'} Medication`,
    Content: lazy(() => import('../v2Modals/MemberMedication/Content')),
    Footer: lazy(() => import('../v2Modals/MemberMedication/Footer')),
    Container: lazy(() => import('../v2Modals/MemberMedication/Container')),
    footerVariant: 'right',
  },
  addPrescription: {
    label: 'Add Prescription',
    Content: lazy(() => import('../v2Modals/AddPrescription/Content')),
    Footer: lazy(() => import('../v2Modals/AddPrescription/Footer')),
    Container: lazy(() => import('../v2Modals/AddPrescription/Container')),
    footerVariant: 'right',
  },
  medicationInteractionAlert: {
    label: 'Medication Interaction Alert',
    Content: lazy(() => import('../v2Modals/MedicationInteractionAlert/Content')),
    Footer: lazy(() => import('../v2Modals/MedicationInteractionAlert/Footer')),
    Container: lazy(() => import('../v2Modals/MedicationInteractionAlert/Container')),
    size: 'l',
    footerVariant: 'right',
    showHeaderCloseButton: false,
  },
  editRxChangePrescription: {
    label: 'Edit Prescription',
    Content: lazy(() => import('../v2Modals/EditRxChangePrescription/Content')),
    Footer: lazy(() => import('../v2Modals/EditRxChangePrescription/Footer')),
    Container: lazy(() => import('../v2Modals/EditRxChangePrescription/Container')),
    footerVariant: 'right',
  },
  confirmRxChangeRequest: {
    label: 'Approve Change Request',
    Content: lazy(() => import('../v2Modals/ConfirmRxChangeRequest/Content')),
    Footer: lazy(() => import('../v2Modals/ConfirmRxChangeRequest/Footer')),
    footerVariant: 'right',
  },
  denyRxChangeRequest: {
    label: 'Deny Change Request',
    Content: lazy(() => import('../v2Modals/DenyRxChangeRequest/Content')),
    Footer: lazy(() => import('../v2Modals/DenyRxChangeRequest/Footer')),
    Container: lazy(() => import('../v2Modals/DenyRxChangeRequest/Container')),
    footerVariant: 'right',
  },
  forgotPassword: {
    label: 'Forgot Password',
    Content: lazy(() => import('../v2Modals/ForgotPassword/Content')),
    Footer: lazy(() => import('../v2Modals/ForgotPassword/Footer')),
  },
  pdfViewer: {
    Content: lazy(() => import('../v2Modals/PDFViewer/Content')),
    label: 'Policy',
    size: 'custom',
    className: 'w-[1000px] max-sm:max-h-[95dvh] [&>_:nth-child(2)]:!overflow-auto !overflow-hidden',
    footerVariant: 'right',
  },
  phoneConfirmation: {
    Container: lazy(() => import('./PhoneConfirmation/Container')),
    Content: lazy(() => import('./PhoneConfirmation/Content')),
    Footer: lazy(() => import('./PhoneConfirmation/Footer')),
    label: 'Verify Phone Number',
    footerVariant: 'right',
  },
  visitActions: {
    label: 'Visit Details',
    Content: lazy(() => import('../v2Modals/VisitActions')),
    Footer: lazy(() => import('../v2Modals/VisitActions/Footer')),
    footerVariant: 'full',
    showHeaderCloseButton: true,
  },
  rescheduleLimit: {
    label: 'Reschedule Limit',
    Content: lazy(() => import('../v2Modals/RescheduleLimitModal')),
    Footer: lazy(() =>
      import('../v2Modals/RescheduleLimitModal').then((mod) => ({ default: mod.Footer })),
    ),
    footerVariant: 'right',
  },
} as const

export type V2ModalMapType = keyof typeof V2ModalsMap

export default V2ModalsMap
